import { render, staticRenderFns } from "./NoContentWithHint.vue?vue&type=template&id=2189f9e6&scoped=true"
import script from "./NoContentWithHint.vue?vue&type=script&lang=ts"
export * from "./NoContentWithHint.vue?vue&type=script&lang=ts"
import style0 from "./NoContentWithHint.vue?vue&type=style&index=0&id=2189f9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189f9e6",
  null
  
)

export default component.exports